import { createSelector } from 'reselect';

/*------------------------------------------------------------------------------------------------*/
/* Collections Selectors                                                                          */
/*------------------------------------------------------------------------------------------------*/
/**
 * collectionsSelector
 * Selector for the catalog collections state.
 * @param { Object } state: The application state.
 * @returns { Object } The catalog collections state.
 */
export const collectionsSelector = (state) => state.catalogs.collections;

export const createCollectionsSelector = (attr) =>
  createSelector(collectionsSelector, (collections) => collections[attr]);

/**
 * Selectors for the catalog collections state.
 * @param { Object } state: The application state.
 * @returns { Any } The value of the determined catalog collections state.
 */
export const selectCollections = createCollectionsSelector('collections');
export const selectFetchParams = createCollectionsSelector('fetchParams');
export const selectIsDeleteModalOpen = createCollectionsSelector('isDeleteModalOpen');
export const selectIsFetchingCollections = createCollectionsSelector('isFetchingCollections');
export const selectIsHandlebarsModalOpen = createCollectionsSelector('isHandlebarsModalOpen');
export const selectSelectedCollection = createCollectionsSelector('selectedCollection');
export const selectSelectedCollectionName = createCollectionsSelector('selectedCollectionName');
export const selectTotalCollections = createCollectionsSelector('total');
export const selectUsesSmartRecosHandlebar = createCollectionsSelector('usesSmartRecos');
